// @flow
import React from 'react';
import Group from 'sail/Group';

import {CountrySetting} from './components/CountrySetting';
import {ReaderSetting} from './components/ReaderSetting';
import {PlatformsForReaderSetting} from './components/PlatformsForReaderSetting';
import {ClientSetting} from './components/ClientSetting';
import {ServerSetting} from './components/ServerSetting';

export const TERMINAL_SETTINGS = {
  readers: {
    US: ['m2', 'wpe'],
    GB: ['wpe', 'wp3'],
    CA: ['wpe', 'wp3'],
    IE: ['wpe', 'wp3'],
  },
  platformsForReader: {
    m2: ['ios', 'android'],
    wpe: ['web', 'ios'],
    wp3: ['ios', 'android'],
  },
  clients: {
    web: ['js', 'esnext'],
    ios: ['swift', 'objc'],
    android: ['kotlin', 'java'],
  },
  servers: ['ruby', 'node', 'php', 'python', 'go', 'dotnet', 'java'],
};

export const TerminalSettings = () => {
  return (
    <Group
      className="TerminalSettings"
      direction="horizontal"
      alignItems="center"
      spacing={24}
    >
      <CountrySetting countries={Object.keys(TERMINAL_SETTINGS.readers)} />
      <ReaderSetting readersForCountry={TERMINAL_SETTINGS.readers} />
      <PlatformsForReaderSetting
        platformsForReader={TERMINAL_SETTINGS.platformsForReader}
        clients={TERMINAL_SETTINGS.clients}
      />
      <ClientSetting clients={TERMINAL_SETTINGS.clients} />
      <ServerSetting servers={TERMINAL_SETTINGS.servers} />
    </Group>
  );
};
